// ModeS - Dual Theme Mode Implementation

// Initialize modes functionality
document.addEventListener('DOMContentLoaded', function() {
  initModes();
});

function initModes() {
  // Check if mode is stored in localStorage
  const currentMode = localStorage.getItem('shopMode') || '';
  
  // Apply stored mode if exists
  if (currentMode === 'mode-a' || currentMode === 'mode-b') {
    document.body.classList.add(currentMode);
    hideModeSelector();
  } else {
    // If no mode is set, show the mode selector
    showModeSelector();
  }
  
  // Set up mode toggle in header if it exists
  const modeToggle = document.querySelector('.mode-toggle');
  if (modeToggle) {
    updateModeToggleLabel(currentMode);
    modeToggle.addEventListener('click', toggleMode);
  }
}

// Show full-screen mode selector
function showModeSelector() {
  const modeSelector = document.querySelector('.mode-selector-container');
  if (modeSelector) {
    modeSelector.classList.remove('hidden');
    
    // Add event listeners to mode options
    const modeOptions = document.querySelectorAll('.mode-option');
    modeOptions.forEach(option => {
      option.addEventListener('click', selectMode);
    });
  }
}

// Hide mode selector
function hideModeSelector() {
  const modeSelector = document.querySelector('.mode-selector-container');
  if (modeSelector) {
    modeSelector.classList.add('hidden');
  }
}

// Handle mode selection from the full-screen selector
function selectMode(event) {
  const selectedMode = event.currentTarget.dataset.mode;
  setMode(selectedMode);
  hideModeSelector();
}

// Toggle between modes when clicking the mode indicator in header
function toggleMode() {
  const currentMode = localStorage.getItem('shopMode') || 'mode-a';
  const newMode = currentMode === 'mode-a' ? 'mode-b' : 'mode-a';
  setMode(newMode);
}

// Set the selected mode
function setMode(mode) {
  // Remove any existing mode classes
  document.body.classList.remove('mode-a', 'mode-b');
  
  // Add the selected mode class
  document.body.classList.add(mode);
  
  // Store the mode in localStorage
  localStorage.setItem('shopMode', mode);
  
  // Update the mode toggle label
  updateModeToggleLabel(mode);
  
  // Trigger a custom event for other scripts that might need to know about mode changes
  document.dispatchEvent(new CustomEvent('modeChanged', { detail: { mode: mode } }));
}

// Update the mode toggle label in the header
function updateModeToggleLabel(mode) {
  const modeLabel = document.querySelector('.current-mode-label');
  if (modeLabel) {
    if (mode === 'mode-a') {
      modeLabel.textContent = 'Cole Henry';
    } else if (mode === 'mode-b') {
      modeLabel.textContent = 'Blanks';
    }
  }
}

// Allow forced display of mode selector (for settings page, etc.)
window.showModeSelectorForced = function() {
  showModeSelector();
};

// Reset mode to none and show selector again
window.resetMode = function() {
  localStorage.removeItem('shopMode');
  document.body.classList.remove('mode-a', 'mode-b');
  showModeSelector();
}; 